<div class="popup-modal popup-modal--full-width">
  <div class="rcr-exchange-error">
    <div
      class="message-container"
      [ngClass]="{
        'message-container--error': modalHasStatusError,
        'message-container--success': modalHasStatusSuccess,
      }"
    >
      <span class="status-icon">
        <i class="fa fa-ban status-icon--md"></i>
      </span>
      <div class="status-message">
        <span class="status-header">Status</span>
        <div class="status-content">{{ statusDisplayMessage }}. {{ statusResolutionMessage }}</div>
      </div>
    </div>
  </div>
</div>
<div class="popup-modal-overlay"></div>
